import { createFeatureSelector, createSelector } from '@ngrx/store'
import {ILpisUserSubjectSearchState} from './lpis-user-subject-search.reducer'
import {StoreKeysEnum} from '../../../../store/store-keys'

export const selectLpisUserSubjectSearchFeature = createFeatureSelector<Readonly<ILpisUserSubjectSearchState>>(StoreKeysEnum.LpisUserSubjectSearchComponent)

export const selectLpisUserSubjectSearchFilterCriteria = createSelector(
    selectLpisUserSubjectSearchFeature,
    feature => (feature.filterCriteria),
)

export const selectLpisUserSubjectSearchItemCollection = createSelector(
    selectLpisUserSubjectSearchFeature,
    feature => (feature.itemCollection),
)
export const selectLpisUserSubjectSearchLpisId = createSelector(
    selectLpisUserSubjectSearchFeature,
    feature => (feature.lpisId),
)
export const selectLpisUserSubjectSearchState = createSelector(
    selectLpisUserSubjectSearchFilterCriteria,
    selectLpisUserSubjectSearchItemCollection,
    selectLpisUserSubjectSearchLpisId,
    (filterCriteria, itemCollection, lpisId) => ({
        filterCriteria, itemCollection, lpisId,
    }),
)